'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'gravityForm', () => ({

		init() {
			const signupModalBtn = document.getElementById( 'signupModal' );
			const cityOptions = document.querySelectorAll( '.newsletter-sites input' );
			let cityLabels = document.querySelectorAll( '.hidden-site-option label' );

			if ( cityOptions ) {
				signupModalBtn.addEventListener( 'click', function() {
					cityOptions.forEach( function( city ) {
						if ( city.checked ) {
							let cityVal = city.nextElementSibling.innerText;
							for ( let i = 0; i < cityLabels.length; i++ ) {
								if ( cityVal === cityLabels[i].innerText ) {
									if ( city.checked ) {
										cityLabels[i].previousElementSibling.checked = true;
									} else {
										cityLabels[i].previousElementSibling.checked = false;
									}
								}
							}
						} else {

						}
					});
				});

				cityOptions.forEach( function( city ) {
					city.addEventListener( 'change', function() {
						let cityVal = this.nextElementSibling.innerText;

						for ( let i = 0; i < cityLabels.length; i++ ) {
							if ( cityVal === cityLabels[i].innerText ) {
								if ( this.checked ) {
									cityLabels[i].previousElementSibling.checked = true;
								} else {
									cityLabels[i].previousElementSibling.checked = false;
								}
							}
						}
					});
				});
			}
		},

	}) );
});